import { Button } from "@/components/Buttons/index";
import ProfileIconImage from "@/components/Images/ProfileIconImage";
import styles from "@/styles/Profile.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useCallback, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import * as y from "yup";
import IconCaution from "../../svgs/icon_caution.svg";
import { HiddenField, PasscodeField } from "./Parts/index";

const schema = y.object().shape({
  passcode: y.string().matches(/^\d{4}$/, "暗証番号を入力してください"),
});

export default function ProfilePasscodeForm({
  profile,
  back,
  onSubmit,
  error,
  resetPin,
  type,
}) {
  const submitBtnRef = useRef();
  const { formState, trigger, register, handleSubmit, control } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
  });
  const { isValid, isSubmitting, errors } = formState;

  const handleChange = useCallback(() => {
    trigger("passcode");
  }, [submitBtnRef]);

  useEffect(() => {
    if (isValid) {
      submitBtnRef.current.focus();
    }
  }, [isValid]);

  return (
    <>
      {type == "auth" && <h2>暗証番号を入力してください</h2>}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className={styles["passcode-form"]}>
          <div className={styles.passcode}>
            {type == "auth" && <ProfileIconImage {...profile} />}
            <div className={styles["passcode-input"]}>
              <h3>暗証番号入力</h3>
              <Controller
                name="passcode"
                control={control}
                defaultValue={profile?.passcode || ""}
                render={({ field }) => (
                  <PasscodeField
                    {...field}
                    defaultValue={field.value}
                    onChange={field.onChange}
                    error={errors.passcode?.message}
                    initialFocus
                  />
                )}
              />
              {error && (
                <span className={styles.errorMessage}>
                  <span className={styles.iconCaution}>
                    <IconCaution />
                  </span>
                  {error.message}
                </span>
              )}
              {profile?.ownerProfile && type == "auth" && resetPin && (
                <div className={styles["passwordReminder"]}>
                  <Button type="button" fillColor fontFixed onClick={resetPin}>
                    お忘れの方は暗証番号リセットメールを送る
                  </Button>
                </div>
              )}
              {!profile?.ownerProfile && type == "auth" && (
                <div className={styles["passwordReminder"]}>
                  お忘れの方はアカウントページから
                  <br />
                  暗証番号をリセットしてください。
                </div>
              )}
            </div>
          </div>
          {type == "auth" && (
            <fieldset className={styles.buttons}>
              <HiddenField {...register("id")} value={profile.id} />
              <Button type="button" onClick={back} borderGray fillGray medium>
                戻る
              </Button>
              <Button
                ref={submitBtnRef}
                type="submit"
                fillColor
                medium
                disabled={!isValid}
                loading={isSubmitting}
              >
                切り替える
              </Button>
            </fieldset>
          )}
          {type == "reset" && (
            <fieldset className={styles.buttons}>
              <Button
                ref={submitBtnRef}
                type="submit"
                fillColor
                medium
                disabled={!isValid}
                loading={isSubmitting}
              >
                変更する
              </Button>
            </fieldset>
          )}
        </div>
      </form>
    </>
  );
}
